function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -1)",
    "data-name": "Group 19867"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59589",
    d: "M28 4h3.31v5.04H28z",
    transform: "translate(-3.966 -.517)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59590",
    d: "m11.8 18.138-3.305-3.31a1.65 1.65 0 1 1 2.333-2.334l3.31 3.311z",
    transform: "translate(-.519 -1.898)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59591",
    d: "m47.427 17.724 2.892-2.9a1.65 1.65 0 1 0-2.333-2.334l-2.9 2.892z",
    transform: "translate(-6.912 -1.898)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 20683",
    width: 6.621,
    height: 3.31,
    rx: 1.655,
    transform: "translate(22.379 1)",
    style: {
      fill: "#ccd0da"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1126",
    cx: 20.69,
    cy: 20.69,
    r: 20.69,
    transform: "translate(5 7.621)",
    style: {
      fill: "#346d92"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1127",
    cx: 17.379,
    cy: 17.379,
    r: 17.379,
    transform: "translate(8.31 10.931)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1128",
    cx: 2.483,
    cy: 2.483,
    r: 2.483,
    transform: "translate(23.207 25.828)",
    style: {
      fill: "#ccd0da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59592",
    d: "M29 1h1.655v3.31H29z",
    transform: "translate(-4.138)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19855"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59593",
    d: "M29.828 19.31a.828.828 0 0 1-.828-.827v-1.655a.828.828 0 1 1 1.655 0v1.655a.828.828 0 0 1-.827.827z",
    transform: "translate(-4.138 -2.587)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59594",
    d: "M22.155 21.366a.828.828 0 0 1-.718-.414l-.828-1.434a.828.828 0 1 1 1.433-.828l.828 1.434a.828.828 0 0 1-.716 1.241z",
    transform: "translate(-2.672 -2.979)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59595",
    d: "M16.538 26.983a.821.821 0 0 1-.414-.111l-1.434-.828a.828.828 0 1 1 .828-1.433l1.434.828a.828.828 0 0 1-.414 1.544z",
    transform: "translate(-1.599 -4.052)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59596",
    d: "M14.483 34.655h-1.655a.828.828 0 1 1 0-1.655h1.655a.828.828 0 0 1 0 1.655z",
    transform: "translate(-1.207 -5.518)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59597",
    d: "M15.106 42.983a.828.828 0 0 1-.414-1.544l1.434-.828a.828.828 0 1 1 .828 1.433l-1.434.828a.821.821 0 0 1-.414.111z",
    transform: "translate(-1.599 -6.811)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59598",
    d: "M21.328 49.079a.828.828 0 0 1-.716-1.241l.828-1.434a.828.828 0 1 1 1.433.828l-.828 1.434a.828.828 0 0 1-.717.413z",
    transform: "translate(-2.672 -7.757)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59599",
    d: "M29.828 51.31a.828.828 0 0 1-.828-.827v-1.655a.828.828 0 1 1 1.655 0v1.655a.828.828 0 0 1-.827.827z",
    transform: "translate(-4.138 -8.104)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59600",
    d: "M38.155 49.079a.828.828 0 0 1-.718-.414l-.828-1.434a.828.828 0 1 1 1.433-.828l.828 1.434a.828.828 0 0 1-.716 1.241z",
    transform: "translate(-5.431 -7.757)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59601",
    d: "M44.251 42.983a.821.821 0 0 1-.414-.111l-1.437-.828a.828.828 0 1 1 .828-1.433l1.434.828a.828.828 0 0 1-.414 1.544z",
    transform: "translate(-6.377 -6.811)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59602",
    d: "M46.483 34.655h-1.655a.828.828 0 0 1 0-1.655h1.655a.828.828 0 0 1 0 1.655z",
    transform: "translate(-6.724 -5.518)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59603",
    d: "M42.819 26.983a.828.828 0 0 1-.414-1.544l1.434-.828a.828.828 0 1 1 .828 1.433l-1.434.828a.821.821 0 0 1-.414.111z",
    transform: "translate(-6.378 -4.052)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59604",
    d: "M37.328 21.366a.828.828 0 0 1-.716-1.241l.828-1.434a.828.828 0 1 1 1.433.828l-.828 1.434a.828.828 0 0 1-.718.414z",
    transform: "translate(-5.431 -2.979)",
    style: {
      fill: "#295474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59605",
    d: "M26.207 48.414a18.207 18.207 0 1 1 18.207-18.207 18.207 18.207 0 0 1-18.207 18.207zm0-34.759a16.552 16.552 0 1 0 16.552 16.552 16.552 16.552 0 0 0-16.552-16.552z",
    transform: "translate(-.517 -1.897)",
    style: {
      fill: "#295474"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59606",
    d: "M30.655 23.828v5.942a2.374 2.374 0 0 0-1.655 0v-5.942a.828.828 0 1 1 1.655 0z",
    transform: "translate(-4.138 -3.793)",
    style: {
      fill: "#dd4747"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59607",
    d: "M37.107 33.828a.828.828 0 0 1-.828.828H32.82a2.373 2.373 0 0 0 0-1.655h3.459a.828.828 0 0 1 .828.827z",
    transform: "translate(-4.797 -5.517)",
    style: {
      fill: "#dd4747"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon3);
export default __webpack_public_path__ + "static/media/delivery-icon3.7093523efb0e15f3273dece104daa453.svg";
export { ForwardRef as ReactComponent };